import React from 'react'
import { PrismicLink, PrismicRichText } from '@prismicio/react'

const Text = ({ slice }) => {
  return (
    <section className={`component-text mx-auto w-full p-6 lg:py-10 ${slice.primary.columns === true && 'columns max-w-screen-2xl lg:columns-2'}`}>
      <div className={`prose dark:prose-invert lg:prose-lg xl:prose-xl ${slice.primary.columns === true ? 'columns' : 'mx-auto max-w-5xl'}`}>
        <PrismicRichText field={slice.primary.text.richText} />
      </div>
      {slice.primary.button_link?.text && (
        <div className='mt-6 text-center'>
          <PrismicLink className='button inline-flex text-lg lg:text-xl' field={slice.primary.button_link}>
            {slice.primary.button_text}
          </PrismicLink>
        </div>
      )}
    </section>
  )
}

export default Text
